import { mapTransform } from '../../../lib/util';
import type { InternalUserSchedule } from '../../Scenario';
import { getShipmentsById } from '../../Scenario';
import type { ClientId } from '../../core/ClientId';
import type { ScenarioMigration } from './migrate';

export const migrateScenarioPatchShipmentsClientIds: ScenarioMigration = (
  scenario,
  migrationData,
): InternalUserSchedule => {
  const shipmentByDbId = getShipmentsById(
    migrationData.persistedShipmentByClientId,
  );

  /** Fix patchOrders to only contain refs by clientId */
  const patchOrders: InternalUserSchedule['patchOrders'] = mapTransform(
    scenario.patchOrders,
    (patch) => {
      let shipmentId = patch.patch.shipmentId;
      if (typeof shipmentId === 'number') {
        shipmentId = shipmentByDbId.get(shipmentId)?.clientId;
      }
      return {
        ...patch,
        patch: {
          ...patch.patch,
          shipmentId,
        },
      };
    },
  );

  /** Fix patchShipments to only be mapped by clientId */
  const patchShipments: InternalUserSchedule['patchShipments'] = new Map();
  for (const [shipmentId, patch] of scenario.patchShipments) {
    let clientId: number | ClientId | undefined = shipmentId;
    if (typeof clientId === 'number') {
      clientId = shipmentByDbId.get(clientId)?.clientId;
    }
    if (clientId !== undefined) {
      patchShipments.set(clientId, patch);
    }
  }

  return {
    ...scenario,
    patchOrders,
    patchShipments,
  };
};
